import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDob]'
})
export class DobDirective {
  constructor(private el: ElementRef,
    private control: NgControl) {
  }
  @HostListener('focusout') onFocusOut() {
    (this.el.nativeElement as HTMLInputElement).value = (this.el.nativeElement as HTMLInputElement).value.trim();
    this.control.control.setValue(this.el.nativeElement.value)
  }
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const inputValue = (this.el.nativeElement as HTMLInputElement).value.trim();
    if(inputValue.length>2){
      let temp1 = this.getDaysInMonth(inputValue.slice(0,2))
      if(inputValue.length==4){
      if(temp1<Number(inputValue.slice(-1)+event.key)){
        event.preventDefault();
      }
    }
    }
    
    if (event.key == "Backspace" || event.key == "Delete") {
      return
    } else if (inputValue.length >= 10 || !/^[0-9]+$/.test(event.key)) {
      event.preventDefault();
    } else if (inputValue.length == 0 && /^[2-9]+$/.test(event.key)) {
      this.control.control.setValue('0' + inputValue)
    }  else if (inputValue.length == 2) {
      if (/^[4-9]+$/.test(event.key)) {
        this.control.control.setValue(inputValue + "/0")
      } else {
        this.control.control.setValue(inputValue + "/")
      }
    } else if (inputValue.length == 3 && /^[4-9]+$/.test(event.key)) {
      let temp_val = inputValue.slice(0, inputValue.length)
      this.control.control.setValue(temp_val + '0')
    } else if (inputValue.length == 4 && Number(inputValue.slice(-1))==3 &&  /^[2-9]+$/.test(event.key)) {
      event.preventDefault();
    }else if (inputValue.length == 5) {
      if(!/^[1-2]+$/.test(event.key)){
       return event.preventDefault();
      }
      this.control.control.setValue(inputValue + "/")
    }    else if (inputValue.length == 6 && !/^[1-2]+$/.test(event.key)) {
      event.preventDefault();
    }
    else if (inputValue.length == 7 && Number(inputValue.slice(-1))==1 &&  /^[0-7]+$/.test(event.key)) {
      event.preventDefault();
    }
  }


  getDaysInMonth(month) {
    return new Date(2020, month, 0).getDate();
}
  // else if (inputValue.length == 1 && /^[3-9]+$/.test(event.key)) {
  //   event.preventDefault();
  // }
}
